export default "__VITE_ASSET__BNUd82Qa__"